var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconCameraFull = function SvgIconCameraFull(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "bhs23krfja",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-490.000000, -374.000000) translate(464.000000, 356.867780) translate(27.154953, 17.500000) translate(0.000000, 0.632803)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#52CB94",
    stroke: "#52CB94",
    filter: "url(#bhs23krfja)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.374,
    d: "M2.022.285C3.348.095 4.674 0 6 0s2.652.095 3.978.285C11.138.45 12 1.445 12 2.617v6.976c0 1.03-.67 1.941-1.652 2.249-1.45.453-2.899.68-4.348.68-1.45 0-2.898-.227-4.348-.68C.67 11.534 0 10.623 0 9.593V2.617C0 1.445.862.45 2.022.285z"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.5,
    d: "M14.04 4.342l1.826-.886c.732-.356 1.613-.05 1.968.681.092.19.142.397.147.608.013.518.019 1.04.019 1.566 0 .545-.007 1.086-.02 1.623-.02.813-.696 1.456-1.509 1.435-.199-.005-.394-.05-.575-.132l-1.788-.818c-.49-.224-.818-.698-.853-1.236l-.004-.065c-.035-.538-.034-1.077.004-1.615.036-.5.335-.942.786-1.161z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 2.739,
    r: 1.174,
    fill: "#52cb94"
  }))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconCameraFull);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-camera-full.7dde28820291af877dc5ac0c4e7eb693.svg";